const DELAY = 500;
const MAX_DELAY = 3000;

function pause(duration: number) {
  return new Promise((res) => setTimeout(res, duration));
}

async function startCallBackWithDelay<T>(
  callback: () => Promise<T>,
  delay = DELAY,
  maxDelay = MAX_DELAY,
) {
  try {
    await callback();
  }
  catch (error) {
    console.error('startCallBackWithDelay error', error);
    await pause(delay);
    await startCallBackWithDelay(callback, Math.min(delay * 2, maxDelay));
  }
}

export default startCallBackWithDelay;
